export interface ExternalPositionDetailResponse {
  externalPositionId: number
  accountId: number
  reconDate: string
  securityID: number
  cusip: string
  isin: string
  sedol: string
  ticker: string
  alternateId: string
  alternateIdDesc: string
  maturityDate: string
  factor: number
  units: number
  unfactorizedUnits: number
  priceScalar: number
  price: number
  unscaledPrice: number
  accruedInterestAmount: number
  accruedInterestPercentage: number
  marketValue: number
  couponRate: number
  description: string
  yield: number
  duration: number
  wal: number
  pendingCash: number
  currencyID: number
  pledgedUnits: number
  aggregateInformation: string
  normalizationModelId: number
  dataSource: string
}

export const properties = [
  'externalPositionId',
  'accountId',
  'reconDate',
  'securityID',
  'cusip',
  'isin',
  'sedol',
  'ticker',
  'alternateId',
  'alternateIdDesc',
  'maturityDate',
  'factor',
  'units',
  'unfactorizedUnits',
  'priceScalar',
  'price',
  'unscaledPrice',
  'accruedInterestAmount',
  'accruedInterestPercentage',
  'marketValue',
  'couponRate',
  'description',
  'yield',
  'duration',
  'wal',
  'pendingCash',
  'currencyID',
  'pledgedUnits',
  'aggregateInformation',
  'normalizationModelId',
  'dataSource',
]

export interface ExternalPositionDetail {
  property: string
  value: string
}
